import { useEffect } from "react";

export const useLockBodyScroll = (
  isActive: boolean | undefined,
  scrollToTop?: boolean
) => {
  useEffect(() => {
    if (isActive) {
      if (scrollToTop) {
        window.scrollTo(0, 0);
      }

      // Prevent scrolling on the body
      document.body.style.overflow = "hidden";
    }

    // Revert to the original overflow style when the component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isActive, scrollToTop]);
};
